import React from "react";
import "./ApplicationButton.css";

interface ApplicationButtonProps {
  href: string; //put actual links where component is called
  label: string;
}

const ApplicationButton: React.FC<ApplicationButtonProps> = ({ href, label }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="application-button"
    >
      <span className="button-label">{label}</span>
    </a>
  );
};

export default ApplicationButton;

/*LIGHTENING BOLT FORM*/

// const FormButton: React.FC<FormButtonProps> = ({ href, label }) => {
//   return (
//     <a
//       href={href}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="form-button"
//     >
//       <>
//         <svg className="button-bolt" viewBox="0 0 24 24">
//           <path d="M13 2L3 14h7v8l10-12h-7z" />
//         </svg>
//         <span className="button-label">{label}</span>
//         <svg className="button-bolt" viewBox="0 0 24 24">
//           <path d="M13 2L3 14h7v8l10-12h-7z" />
//         </svg>
//       </>
//     </a>
//   );
// };
